<template>
  <el-form-item
    class="elsa-input"
    show-message
    :label="$attrs.label"
    :prop="$attrs.prop"
    :name="$attrs.name"
  >
    <vue-tags-input
      class="elsa-input elsa-tags-input"
      v-model="email"
      :tags="currentEmails"
      :add-on-blur="true"
      :placeholder="$attrs.placeholder"
      :validation="validations"
      :add-from-paste="true"
      :separators="[ '\n', '\r\n', ';', ',', ' ']"
      @tags-changed="handleChange"
    />
  </el-form-item>
</template>

<script>
  import VueTagsInput from '@johmun/vue-tags-input';

  export default {
    components: {
      VueTagsInput,
    },
    props: ['currentEmails'],
    data() {
      return {
        email: '',
        validations: [
          {
            classes: 'no-email',
            rule: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            disableAdd: true,
          }
        ],
      }
    },
    methods: {
      handleChange(tags) {
        this.$emit('updatedTags', tags)
      }
    },
  }
</script>

<style lang="scss" scoped>
@import '../../scss/colors';
.elsa-tags-input {
  min-height: 116px;
  max-width: none !important;
  border: 1px solid #E6E6E6;
  box-sizing: border-box;
  border-radius: 8px;

  &::v-deep .ti-input {
    border: none;
    font-family: 'SF Pro Display';
    .ti-new-tag-input {
      padding: 5px;
      padding-bottom: 30px;
    }
    .ti-tag {
      font-weight: normal;
      font-size: 12px;
      color: $black;
      background: #FFFFFF;
      border: 0.5px solid #CEE0EA;
      box-sizing: border-box;
      height: 24px;

      span {
        padding: 0 8px 0 8px;
      }

      .ti-actions {
        margin: 0px;
        color: $dark-blue-2;
      }


      &.ti-invalid {
        color: red;
      }
    }
  }
}
</style>
